import { render, staticRenderFns } from "./makes-upper.vue?vue&type=template&id=4843224e"
import script from "./makes-upper.vue?vue&type=script&lang=js"
export * from "./makes-upper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports